import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Download, Lock } from "lucide-react";
import { media, SITE } from "@/lib/api";
import { makeStoryCard, download } from "@/lib/storyCard";

const KINDS = [["onair", "On Air Now", true], ["chart", "Weekly Chart", false], ["award", "Selected by Fuorionda", false]];

export const Cards = ({ d }) => {
  const u = d.user;
  const [imgs, setImgs] = useState({});
  const kinds = (u.badges || []).includes("Artist of the Month") ? [...KINDS, ["aotm", "Artist of the Month", false]] : KINDS;
  const paid = d.plan.id !== "free";
  const track = d.tracks.find((t) => t.status === "approved")?.title || d.tracks[0]?.title;
  const extra = { onair: d.upcoming[0] ? `NEXT PLAY ${new Date(d.upcoming[0].start).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}` : "", chart: d.blind_rank ? `BLIND CHART #${d.blind_rank}` : d.fan_rank ? `FAN CHART #${d.fan_rank}` : "", award: (u.badges || []).includes("Founding Artist") ? "FOUNDING ARTIST" : "", aotm: "" };

  useEffect(() => {
    (async () => {
      const out = {};
      for (const [k] of kinds) out[k] = await makeStoryCard({ kind: k, name: u.stage_name, track, photo: media(u.photo), extra: extra[k], url: `${SITE}/${k === "onair" ? "radio" : `a/${u.slug}`}` });
      setImgs(out);
    })();
  }, [u.stage_name, u.photo, track]); // eslint-disable-line

  return (
    <div data-testid="dash-cards">
      <p className="mb-6 max-w-2xl text-slate-400">Ready-made 1080×1920 cards for your Instagram Stories. Post the On Air Now card when you get our email, and add a link sticker to your page.</p>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {kinds.map(([k, label, needsPaid]) => {
          const locked = needsPaid && !paid;
          return (
            <div key={k} className="panel p-4" data-testid={`story-card-${k}`}>
              <div className="relative aspect-[9/16] overflow-hidden rounded-xl bg-[#07090E]">
                {imgs[k] && <img src={imgs[k]} alt={label} className={`h-full w-full object-cover ${locked ? "blur-md" : ""}`} />}
                {locked && <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 p-4 text-center"><Lock className="h-6 w-6 text-[#FFB800]" /><p className="text-sm">On Air Now cards are included in Artist and Pro.</p><Link to="/dashboard?tab=plan" className="btn-hot !px-4 !py-2 text-xs">Upgrade</Link></div>}
              </div>
              <div className="mt-4 flex items-center justify-between">
                <span className="font-display font-bold">{label}</span>
                <button disabled={locked || !imgs[k]} onClick={() => download(imgs[k], `fuorionda-${k}-${u.slug}.png`)} className="btn-ghost !px-4 !py-2 text-xs disabled:opacity-40" data-testid={`story-card-download-${k}`}><Download className="h-4 w-4" />PNG</button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
